/** @jsx jsx */
// TODO: remove eslint statement when 'css' is implemented
import {jsx} from '@emotion/react';
// eslint-disable-next-line no-unused-vars
import React from 'react';
import {PropertyFlag as SrsPropertyFlag, PropertyType as SrsPropertyType} from 'srs-middleware';
import {PropertyListSelector} from 'components/selectors/propertyListSelector';
import {BooleanSelector} from 'components/selectors/booleanSelector';
import {LimitSelector} from 'components/selectors/limitSelector';
import {EndpointPropertySelector} from 'components/selectors/endpointPropertySelector';
import {EndpointParameterSelector} from 'components/selectors/endpointParameterSelector';
import {AGGREGATION_METHOD_VALUES} from 'widgets/chartUtils';
import CommonKnobsContainer from "views/common/commonKnobsContainer";
import {Tab, Tabs} from "@blueprintjs/core";

/**
 * Custom renderer for the controls available to change the chart settings.
 *
 * Data Properties for this Widget:
 *   -- propertyList
 *   -- limit
 *
 * Chart Properties for this Widget:
 *
 * @param chartConfiguration
 * @param updateConfiguration
 * @returns {*}
 * @constructor
 */
export const CustomPackKnobs = ({cardIndex, endpointQuery, widgetConfiguration}) => {
	return (
		<Tabs>
			<Tab id="data" title="Data" panel={
				<React.Fragment>
					<CommonKnobsContainer>
						<PropertyListSelector
							cardIndex={cardIndex}
							itemIndex={0}
							flags={[SrsPropertyFlag.Categorical]}
							label={'Top Level Group'}
							endpointQuery={endpointQuery}
							cy-test="top-level-dropdown-button"
						/>
						<PropertyListSelector
							cardIndex={cardIndex}
							itemIndex={1}
							flags={[SrsPropertyFlag.Categorical]}
							label={'2nd Level Group'}
							endpointQuery={endpointQuery}
							isNullable
							cy-test="second-level-dropdown-button"
						/>
						<PropertyListSelector
							cardIndex={cardIndex}
							itemIndex={2}
							flags={[SrsPropertyFlag.Categorical]}
							label={'3nd Level Group'}
							endpointQuery={endpointQuery}
							isNullable
							cy-test="third-level-dropdown-button"
						/>
					</CommonKnobsContainer>
					<CommonKnobsContainer>
						<LimitSelector
							cardIndex={cardIndex}
							endpointQuery={endpointQuery}
							widgetConfiguration={widgetConfiguration}
							label={'Root Count'}
							limitProperty="maxRoot"
							cy-test="root-count-dropdown-button"
						/>
						<LimitSelector
							cardIndex={cardIndex}
							endpointQuery={endpointQuery}
							widgetConfiguration={widgetConfiguration}
							label={'Child Count'}
							limitProperty="maxChildren"
							cy-test="child-count-dropdown-button"
						/>
					</CommonKnobsContainer>
					<CommonKnobsContainer>
						<EndpointPropertySelector
							cardIndex={cardIndex}
							endpointQuery={endpointQuery}
							propertyName="distinctProperty"
							flags={[SrsPropertyFlag.Categorical]}
							types={[SrsPropertyType.String]}
							label="Distinct Property"
							isNullable={true}
							cy-test="distinct-dropdown-button"
						/>
						<EndpointPropertySelector
							cardIndex={cardIndex}
							endpointQuery={endpointQuery}
							propertyName="aggregationProperty"
							types={[SrsPropertyType.Numeric]}
							label="Aggregation Property"
							isNullable={true}
							cy-test="aggregation-dropdown-button"
						/>
						<EndpointParameterSelector
							cardIndex={cardIndex}
							endpointQuery={endpointQuery}
							propertyName="aggregationMethod"
							label="Aggregation Method"
							values={AGGREGATION_METHOD_VALUES}
							defaultValue={AGGREGATION_METHOD_VALUES[0]}
							cy-test="aggregation-method-dropdown-button"
						/>
					</CommonKnobsContainer>
				</React.Fragment>
			}/>
			<Tab id="style" title="Style" panel={
				<React.Fragment>
					<CommonKnobsContainer>
						<BooleanSelector
							cardIndex={cardIndex}
							widgetConfiguration={widgetConfiguration}
							propertyName={'showAllLabels'}
							label={'Show 2nd and 3rd Level Labels'}
							cy-test="show-all-labels-checkbox"
						/>
					</CommonKnobsContainer>
				</React.Fragment>
			}/>
		</Tabs>
	);
};
